import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import KanbanCard from './KanbanCard';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: 260,
    minWidth: 260,
    maxWidth: 260,
    marginRight: 8,
    flexShrink: 0,
    height: '100%',
  },
  columnHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 4px 10px 4px',
    gap: 8,
  },
  colorDot: props => ({
    width: 10,
    height: 10,
    borderRadius: '50%',
    background: props.color || '#c7c7c7',
    flexShrink: 0,
  }),
  columnTitle: {
    fontSize: '0.72rem',
    fontWeight: 700,
    color: '#6b6b6b',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  countBadge: {
    fontSize: '0.7rem',
    fontWeight: 600,
    color: '#9b9b9b',
    background: '#f0f0f0',
    borderRadius: 4,
    padding: '1px 6px',
    flexShrink: 0,
  },
  cardList: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: 2,
    '&::-webkit-scrollbar': {
      width: 4,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#e0e0e0',
      borderRadius: 2,
    },
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 0',
    marginTop: 4,
    border: '1px dashed #d4d4d4',
    borderRadius: 8,
    cursor: 'pointer',
    color: '#b0b0b0',
    fontSize: '0.8rem',
    fontWeight: 500,
    background: 'transparent',
    transition: 'all 0.15s ease',
    flexShrink: 0,
    '&:hover': {
      borderColor: '#a0a0a0',
      color: '#6b6b6b',
      background: '#fafafa',
    },
  },
  droppableArea: {
    minHeight: 40,
    flex: 1,
  },
  columnInner: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    background: '#f7f7f5',
    borderRadius: 10,
    padding: '10px 8px 8px',
  },
}));

const KanbanColumn = ({ id, title, tickets, color, index, updateTicket, removeTicket, isAdmin, onAddToColumn, connections }) => {
  const classes = useStyles({ color });

  return (
    <Draggable draggableId={id} index={index} isDragDisabled={!isAdmin}>
      {(provided) => (
        <div
          className={classes.column}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <div className={classes.columnInner}>
            {/* Header */}
            <div
              className={classes.columnHeader}
              {...(isAdmin ? provided.dragHandleProps : {})}
            >
              <span className={classes.colorDot} />
              <Typography className={classes.columnTitle}>
                {title}
              </Typography>
              <span className={classes.countBadge}>{tickets.length}</span>
            </div>

            {/* Cards */}
            <Droppable droppableId={id} type="CARD">
              {(provided, snapshot) => (
                <div
                  className={classes.cardList}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    background: snapshot.isDraggingOver ? '#efefed' : 'transparent',
                    borderRadius: 8,
                    transition: 'background 0.15s ease',
                  }}
                >
                  <div className={classes.droppableArea}>
                    {tickets.map((ticket, idx) => (
                      <KanbanCard
                        key={ticket.id}
                        ticket={ticket}
                        index={idx}
                        updateTicket={updateTicket}
                        removeTicket={removeTicket}
                        connections={connections || []}
                      />
                    ))}
                    {provided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>

            {/* Add button */}
            <div className={classes.addButton} onClick={() => onAddToColumn && onAddToColumn(id)}>
              + Adicionar
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default KanbanColumn;
